module.exports = __webpack_public_path__ + "media/components/country-flag/static/ai-f991e7d3952f81c3424a9fa4ff32cf6b.svg";